import { api } from "@/lib/api";
import {
  mapProviderFromDto,
  mapProviderToDto,
  Provider,
  ProviderDtoSchema,
} from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getProviderQueryOptions, getProvidersQueryOptions } from "./get.hooks";

export function useUpdateProvider(opts?: {
  onSuccess?: (provider: Provider) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (provider: Provider) => {
      const dto = mapProviderToDto(provider);
      const result = await api.put("/api/providers", dto, ProviderDtoSchema);
      return mapProviderFromDto(result);
    },
    onSuccess: (provider) => {
      queryClient.setQueryData(getProvidersQueryOptions.queryKey, (old) =>
        old?.map((p) => (p.id === provider.id ? provider : p)),
      );
      queryClient.setQueryData(
        getProviderQueryOptions(provider.id).queryKey,
        () => provider,
      );
      toast({
        title: "toast.providerUpdated",
        variant: "success",
      });
      opts?.onSuccess?.(provider);
    },
    onError: () => {
      toast({
        title: "toast.updateProviderError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
